<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <b-container fluid style="margin-top: 70px">
      <b-row>
        <b-col>
          <b-breadcrumb>
            <b-breadcrumb-item
                text="Profile"
                active>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
    </b-container>
    <yega1-modal-form ref="input_form"
                      store-name="DeviseAuthStore"
                      v-on:cancelled="handleCancelled"
                      no-destroy>
      <template v-slot:header>
        <h2>User Profile</h2>
      </template>
      <template v-slot:fields="data">
        <yega1-form-group-input label="Username"
                                :item="data.item"
                                field="username"
                                required>
        </yega1-form-group-input>
        <yega1-form-group-input label="First Name"
                                :item="data.item"
                                field="first_name">
        </yega1-form-group-input>
        <yega1-form-group-input label="Last Name"
                                :item="data.item"
                                field="last_name">
        </yega1-form-group-input>
        <yega1-form-group-input label="E-Mail"
                                :item="data.item"
                                field="email"
                                type="email"
                                required>
        </yega1-form-group-input>
        <yega1-form-group-input label="Password"
                                :item="data.item"
                                field="password"
                                type="password">
        </yega1-form-group-input>
      </template>
    </yega1-modal-form>
  </div>
</template>

<script>
import Yega1ModalForm from "./yega1-modal-form.vue";
import Yega1FormGroupInput from "./yega1-form-group-input.vue";

export default {
  name: "yega1-user-profile-form",
  components: {
    Yega1FormGroupInput,
    Yega1ModalForm
  },
  provide(){
    return{
      registerDialog: this.registerDialog,
      handleItemSaved: this.handleItemSaved,
      handleItemUpdated: this.handleItemUpdated,
      handleItemDestroyed: this.handleItemDestroyed
    };
  },
  data(){
    return {
      dialog: null
    };
  },
  mounted() {
    this.$refs.input_form.loadItem();
  },
  methods: {
    registerDialog(dialog){
      this.dialog= dialog;
    },
    handleItemSaved(){
    },
    handleItemUpdated() {
      window.location.href = '/';
    },
    handleCancelled() {
      window.location.href = '/';
    },
    handleItemDestroyed(){

    }
  }
}
</script>

<style scoped>

</style>
